module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-regular-f94f84eb867a3e3d65da0c5cad065437.bundle.woff";